import { TEmployeeApplicationForm } from "@/features/renew-visa/types/employeeApplicationForm";
import { background, divider, state, text } from "@/theme/colors";
import { convertFullWidthToHalfWidth } from "@/utils/pieces";
import { InputBase, Stack, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

type TRelatedActivitySpecificSkillTransitionPeriodInputProps = {
  readonly: boolean;
};

export const RelatedActivitySpecificSkillTransitionPeriodInput: FC<TRelatedActivitySpecificSkillTransitionPeriodInputProps> = ({ readonly }) => {
  const { getValues, setValue, getFieldState, trigger } = useFormContext<TEmployeeApplicationForm>();

  const formYear = getValues("relatedActivitySpecificSkillTransitionPeriodYear") ?? null;
  const formMonth = getValues("relatedActivitySpecificSkillTransitionPeriodMonth") ?? null;

  const isError =
    !!getFieldState("relatedActivitySpecificSkillTransitionPeriodYear").error ||
    !!getFieldState("relatedActivitySpecificSkillTransitionPeriodMonth").error;

  const [year, setYear] = useState<number | null>(formYear);
  const [month, setMonth] = useState<number | null>(formMonth);

  useEffect(() => {
    setYear(formYear);
  }, [formYear]);

  useEffect(() => {
    setMonth(formMonth);
  }, [formMonth]);

  const onChangeYear: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const val = e.target.value as unknown as number;
    setYear(val);
    setValue("relatedActivitySpecificSkillTransitionPeriodYear", val || null, { shouldDirty: true });
  };

  const onBlurYear = async (e: React.FocusEvent<HTMLInputElement>) => {
    const val = convertFullWidthToHalfWidth(e.target.value);
    setValue("relatedActivitySpecificSkillTransitionPeriodYear", (val as unknown as number) || null, { shouldDirty: true });
    await trigger("relatedActivitySpecificSkillTransitionPeriodYear");
    await trigger("relatedActivitySpecificSkillTransitionPeriodMonth");
  };

  const onChangeMonth: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const val = e.target.value as unknown as number;
    setMonth(val);
    setValue("relatedActivitySpecificSkillTransitionPeriodMonth", val || null, { shouldDirty: true });
  };

  const onBlurMonth = async (e: React.FocusEvent<HTMLInputElement>) => {
    const val = convertFullWidthToHalfWidth(e.target.value);
    setValue("relatedActivitySpecificSkillTransitionPeriodMonth", (val as unknown as number) || null, { shouldDirty: true });
    await trigger("relatedActivitySpecificSkillTransitionPeriodMonth");
    await trigger("relatedActivitySpecificSkillTransitionPeriodYear");
  };

  return (
    <Stack
      direction="row"
      gap={0.4}
      justifyContent="space-between"
      alignItems="center"
      border={`1px solid ${isError ? state.error_1 : divider.middle}`}
      bgcolor={readonly ? background.disable : isError ? "#FCDFE4" : undefined}
      borderRadius={1}
      sx={{ pointerEvents: readonly ? "none" : undefined }}
      px={1}
    >
      <InputBase
        name="relatedActivitySpecificSkillTransitionPeriodYear"
        sx={{ maxWidth: "40px", fontSize: "14px" }}
        value={year}
        onChange={onChangeYear}
        onBlur={onBlurYear}
        placeholder="0"
        readOnly={readonly}
      />
      <Typography variant="body14" color={text.primary}>
        年
      </Typography>
      <InputBase
        name="relatedActivitySpecificSkillTransitionPeriodMonth"
        sx={{ maxWidth: "40px", fontSize: "14px" }}
        value={month}
        onChange={onChangeMonth}
        onBlur={onBlurMonth}
        placeholder="00"
        readOnly={readonly}
      />
      <Typography variant="body14" color={text.primary}>
        か月
      </Typography>
    </Stack>
  );
};
